export default __webpack_public_path__ + "4bec18ad7f575e6c1c33466a9e568d35.png";